import * as ActionType from '../actions/step';
import Logger from "../../tools/logger";

const defaultState = {
	activeStep: {
		id: "game-intro",
		ref: "views",
		section: "introduction",
		type: "game-intro"
	}
};

/**
 * @description
 * get the setup data required for every page of the app.
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function step (state = defaultState, action) {
	let newState = { ...state };

	switch (action.type) {

		case ActionType.SET_STEP : {
			newState.activeStep = state.steps[action.activeIndex];
			newState.activeIndex = action.activeIndex;

			// log current step, this is one time action
			Logger.instance.notice({
				component: 'next-step',
				message: `set step: ${newState.activeStep.id}`
			});

			return newState;
		}

		case ActionType.NEXT_STEP : {
			const newIndex = newState.activeIndex + 1;

			newState.activeStep = newState.steps[newIndex];
			newState.activeIndex = newIndex;

			// log current step, happens on every step change
			Logger.instance.notice({
				component: 'next-step',
				message: `next step: ${newState.activeStep.id}`
			});

			return newState;
		}

		case ActionType.STORE_STEPS : {
			newState.steps = action.steps;
			return newState;
		}

		default:
			return state;
	}

}
